import {Component, Input, OnInit} from '@angular/core';
import {Lightbox} from "ngx-lightbox";
import {Recipe} from "../../../dtos/recipe";

@Component({
  selector: 'app-recipe-image',
  templateUrl: './recipe-image.component.html',
  styleUrls: ['./recipe-image.component.css']
})
export class RecipeImageComponent implements OnInit {

  @Input() recipe: Recipe;
  public imageUrl: string = null;

  constructor(private _lightbox: Lightbox) {}

  ngOnInit() {
    if (this.recipe != null) {
      this.imageUrl = this.recipe.downloadURL;
    }
  }

  openLightbox() {
    this._lightbox.open([
      {
        src: this.imageUrl,
        thumb: this.imageUrl
      }
    ]);
  }

}
